import { Popover, Transition } from "@headlessui/react"
import { useLocation } from "@reach/router"
import { Link, graphql, useStaticQuery } from "gatsby"
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react"

import MenuItem from "./MenuItem"

export default function Topbar({ locale, postType, translationUri }) {
  const [displayLang, setDisplayLang] = useState(false)
  const [shadow, setShadow] = useState(false)
  const currentLangLabel = locale === "en_GB" ? "EN" : "FR"
  const switchLangLabel = locale === "en_GB" ? "FR" : "EN"
  const location = useLocation()

  const {
    topbar: topbar_source,
    topbar_en: topbar_en_source,
  } = useStaticQuery(graphql`
    query topbarQuery {
      topbar: wpMenu(id: { eq: "dGVybToxMQ==" }) {
        menuItems {
          nodes {
            parentId
            label
            path
            childItems {
              nodes {
                path
                label
              }
            }
          }
        }
      }
      topbar_en: wpMenu(id: { eq: "dGVybToxNDY=" }) {
        menuItems {
          nodes {
            parentId
            label
            path
            childItems {
              nodes {
                path
                label
              }
            }
          }
        }
      }
    }
  `)

  const topbar = useMemo(
    () => topbar_source?.menuItems?.nodes?.filter(item => !item.parentId),
    [topbar_source?.menuItems?.nodes]
  )

  const topbar_en = useMemo(
    () => topbar_en_source?.menuItems?.nodes?.filter(item => !item.parentId),
    [topbar_en_source?.menuItems?.nodes]
  )

  const checkShadow = useCallback(() => {
    if (typeof window !== "undefined") {
      setShadow(window.pageYOffset > 0)
    }
  }, [setShadow])

  useEffect(() => {
    window.addEventListener("scroll", checkShadow)
    return () => {
      window.removeEventListener("scroll", checkShadow)
    }
  })
  const isCurrent = item => {
    return (
      location.pathname === item.path ||
      (postType === "post" && item.path === "/blog/")
    )
  }

  const menu = locale === "en_GB" ? topbar_en : topbar
  return (
    <div
      className={`fixed z-50 w-full transition-all bg-white/95 ${
        shadow ? "shadow-lg" : ""
      }
      `}
    >
      <div className="relative py-2">
        <Popover>
          <nav
            className="relative z-10 flex items-center gap-2 justify-between  px-4 mx-auto  sm:px-6 lg:px-8 lg:max-w-7xl"
            aria-label="Global"
          >
            <div className="flex items-center grow shrink">
              <div className="flex items-center justify-between w-full md:w-auto">
                <Link to={locale === "en_GB" ? "/en" : "/"}>
                  <img
                    className="w-auto h-12 md:h-14 lg:h-16"
                    src="/logo.png"
                    alt="swizi"
                  />
                </Link>
                <div className="flex items-center md:hidden">
                  {/* <div className="relative flex items-center text-right">
                    <button
                      type="button"
                      onClick={() => setDisplayLang(!displayLang)}
                      className="cursor-pointer"
                    >
                      <div className="flex items-center gap-2 px-4 py-2">
                        <img
                          className="w-5"
                          src={`./${currentLangLabel}-flag.svg`}
                          alt={currentLangLabel}
                        />
                        <span>{currentLangLabel}</span>
                        <i className="w-5 leading-5 text-center bx bx-caret-down" />
                      </div>
                    </button>
                    {displayLang && (
                      <div className="absolute left-0 z-10 block px-4 py-2 text-base font-medium bg-white border border-transparent rounded-md shadow-lg top-full">
                        <Link
                          href={translationUri}
                          className="flex items-center gap-2"
                        >
                          <img
                            className="w-5"
                            src={`./${switchLangLabel}-flag.svg`}
                            alt={switchLangLabel}
                          />
                          <span>{switchLangLabel}</span>
                        </Link>
                      </div>
                    )}
                  </div> */}
                  <Popover.Button className="inline-flex items-center justify-center p-2 text-orangeSafe bg-white rounded-md shadow-md ring-1 ring-black ring-opacity-5 hover:text-orangeSafe hover:bg-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-cabaret-500">
                    <span className="sr-only">Open main menu</span>
                    <i className="w-6 h-6 text-2xl leading-6 bx bx-menu-alt-right" />
                  </Popover.Button>
                </div>
              </div>
            </div>
            <div className="flex items-center hidden md:flex">
              <div className="hidden  md:flex md:gap-4 lg:gap-10">
                {menu &&
                  menu.map(item => (
                    <MenuItem
                      key={item.label}
                      item={item}
                      isCurrent={isCurrent(item)}
                    />
                  ))}
              </div>
              <a
                href="/contact"
                className="md:ml-4 lg:ml-10  inline-flex btn px-4 py-2 shadow-sm"
              >
                Contact
              </a>
              {/* <div className="relative flex items-center mr-3 text-right">
                  <button
                    type="button"
                    onClick={() => setDisplayLang(!displayLang)}
                    className="cursor-pointer"
                  >
                    <div className="flex items-center gap-2 px-4 py-2">
                      <img
                        className="w-5"
                        src={`/${currentLangLabel}-flag.svg`}
                        alt={currentLangLabel}
                      />
                      <span>{currentLangLabel}</span>
                      <i className="w-5 h-5 leading-5 text-center bx bx-caret-down" />
                    </div>
                  </button>
                  {displayLang && (
                    <div className="absolute left-0 z-10 block text-base font-medium bg-white border border-transparent rounded-md shadow-lg top-full">
                      <Link
                        href={translationUri}
                        className="flex items-center gap-2 px-4 py-2"
                      >
                        <img
                          className="w-5"
                          src={`/${switchLangLabel}-flag.svg`}
                          alt={switchLangLabel}
                        />
                        {switchLangLabel}
                      </Link>
                    </div>
                  )}
                </div> */}
            </div>
          </nav>

          <Transition
            as={Fragment}
            enter="duration-150 ease-out"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="duration-100 ease-in"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Popover.Panel
              focus
              className="absolute inset-x-0 top-0 z-10 p-2 transition origin-top-right transform md:hidden"
            >
              <div className="overflow-hidden bg-white rounded-lg shadow-md ring-1 ring-black ring-opacity-5">
                <div className="flex items-center justify-between px-5 pt-4">
                  <div>
                    <img className="w-auto h-8" src="/logo.png" alt="swizi" />
                  </div>
                  <div className="-mr-2">
                    <Popover.Button className="inline-flex items-center justify-center p-2 text-orangeSafe bg-white rounded-md hover:text-orangeSafe hover:bg-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-cabaret-500">
                      <span className="sr-only">Close main menu</span>
                      <i className="w-6 h-6 text-2xl leading-6 bx bx-x" />
                    </Popover.Button>
                  </div>
                </div>
                <div className="px-2 pt-2 pb-3 space-y-1">
                  {menu &&
                    menu.map(item => (
                      <span key={item.label}>
                        <a
                          href={item.path}
                          className="block px-3 py-2 text-base font-medium text-gray-700 rounded-md hover:text-gray-900 hover:bg-charlestonGreen-100"
                        >
                          {item.label}
                        </a>
                        {item?.childItems?.nodes?.map(i => (
                          <a
                            key={i.label}
                            href={i.path}
                            className="block ml-2 px-3 py-2 text-base font-medium text-gray-700 rounded-md hover:text-gray-900 hover:bg-gray-100"
                          >
                            <i className="bx bx-chevron-right mr-2" />
                            {i.label}
                          </a>
                        ))}
                      </span>
                    ))}
                </div>

                <a
                  href="/contact"
                  className="block w-full px-5 py-3 font-medium text-center text-white bg-orangeSafe hover:bg-orange-600"
                >
                  Contact
                </a>
              </div>
            </Popover.Panel>
          </Transition>
        </Popover>
      </div>
    </div>
  )
}
